import { ajaxURL } from './variables.js';

window.addEventListener('DOMContentLoaded', () => {


    // get .da__logout
    let logoutButton = document.querySelector('.da__logout');
    if( !logoutButton ) return;

    logoutButton.addEventListener('click', (e) => {

        e.preventDefault();

        let data = new FormData();
        data.append('action', 'logout_user');
        fetch(ajaxURL, {
            method: 'POST',
            body: data
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if (data.success) {
                window.location.href = data.redirect;
            }
        })
        .catch(error => {
            console.log(error);
        });


    });


});